import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('IconVerticalAlignment', null, { withChildren: true });
